module.exports = __webpack_public_path__ + "static/media/severity_low.5eb2e3b3.svg";